@for (payment of paymentRecords; track $index) {
<div *ngFor="let payment of paymentRecords" class="d-flex flex-column p-2 w-100">
  <div class="d-flex flex-row justify-content-between background m-1 p-1 corners">
    <h4 class="font-weight-bold">Montant</h4>
    <h4 class="font-weight-bold">
      {{ payment.totalPrice }}&nbsp;€
    </h4>
  </div>
  <table class="table table-striped">
    <thead>
      <tr>
        <th>Date</th>
        <th>Montant</th>
        <th>{{ ((payment.giftCodes || []).length > 0) ? 'Code' : '' }}</th> 
        <th>Statut</th>
      </tr>
    </thead>
    <tbody>
      @if(!payment.totalPrice) {
      <tr>
        <td>
          {{ dayjs(payment.date).format('DD/MM/YYYY') }}
        </td>
        <td>
          Montant total
        </td>
        <td></td>
        <td>
          {{ ["Confirm", "VALIDATED"].includes(payment.status) ? 'Confirmé' : 'A confirmer' }}
        </td>
      </tr>
      } @else if((payment.amount || 0) > 0) {
      <tr>
        <td>
          {{ dayjs(payment.date).format('DD/MM/YYYY') }}
        </td>
        <td>
          {{ payment.amount }}&nbsp;€
        </td>
        <td>
          {{ payment.paymentId }}
        </td>
        <td>
          {{ ["Confirm", "VALIDATED"].includes(payment.status) ? 'Confirmé' : 'A confirmer' }}
        </td>
      </tr>
      }
      @if((payment.leftToPay || 0) > 0 && payment.dueDate) {
      <tr>
        <td>
          {{ dayjs(payment.dueDate).format('DD/MM/YYYY') }}
        </td>
        <td>
          {{ payment.leftToPay }}&nbsp;€
        </td>
        <td>
          {{ payment.paymentId }}
        </td>
        <td>
          A débiter
        </td>
      </tr>
      }
      @for(code of payment.giftCodes; track code) {
      <tr>
        <td>
          {{ dayjs(payment.date).format('DD/MM/YYYY') }}
        </td>
        <td>
          {{ code.price }}&nbsp;€
        </td>
        <td>
          {{ code.code}}
        </td>
        <td>
          Utilisé
        </td>
      </tr>
      }
      @if(payment.redeemedGiftCode?.code) {
      <tr>
        <td>
          {{ dayjs(payment.date).add(1, 'year').format('DD/MM/YYYY') }}
        </td>
        <td>
          +&nbsp;{{ payment.redeemedGiftCode?.price }}&nbsp;€
        </td>
        <td>
          {{ payment.redeemedGiftCode?.code }}
        </td>
        <td>
          Nouveau
        </td>
      </tr>
      }
    </tbody>
  </table>
  @if(payment.accountAuthorizationId) {
  <div class="d-flex flex-row align-items-center gap-2 m-1 p-1">
    <mat-icon style="color: var(--primary)">account_balance</mat-icon>
    <span class="font-weight-bold">Paiement en compte</span>
    <span class="text-muted" style="font-size: 0.85em">— Autorisation : {{ payment.accountAuthorizationId }}</span>
  </div>
  }
</div>
}